import { BUTTON_TYPE } from "../../../../optics/components/drawers/settings/features/button/defaults";

export const ICON_ELEMENTS = [BUTTON_TYPE.ICON, BUTTON_TYPE.TEXT_AND_ICON];
export const TEXT_ELEMENTS = [BUTTON_TYPE.TEXT, BUTTON_TYPE.TEXT_AND_ICON];
